import { render, staticRenderFns } from "./ApeTable.vue?vue&type=template&id=d6ba078a&scoped=true"
import script from "./ApeTable.vue?vue&type=script&lang=js"
export * from "./ApeTable.vue?vue&type=script&lang=js"
import style0 from "./ApeTable.vue?vue&type=style&index=0&id=d6ba078a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ba078a",
  null
  
)

export default component.exports